import React, { useState } from 'react';
import './Services.css';
import Header from "../components/Header";
import Footer from "../components/Footer";
import Chatbot from '../components/Chatbot';

const Services = () => {
  const [selectedService, setSelectedService] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const services = 
  [
    {
      "title": "Architectural Design & Execution",
      "description": "End-to-end building solutions from concept to construction",
      "detailedDescription": "We shape built environments through comprehensive architectural services, from initial concept and sanction drawings to detailed construction planning and project management.",
      "image": "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=800&q=80",
      "features": ["Concept Design", "Sanction Drawings", "Construction Detailing", "Project Management Consultancy"]
    },
    {
      "title": "Interior Design & Turnkey Solutions",
      "description": "From layout to execution, personalized interiors that speak your style",
      "detailedDescription": "We provide bespoke interior solutions including theme planning, modular furniture, and complete turnkey project execution to bring your vision to life.",
      "image": "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80",
      "features": ["Bespoke Styling", "Modular Furniture", "Turnkey Execution"]
    },
    {
      "title": "Visualisation & Technology Integration",
      "description": "Visualize your space with tech-enhanced solutions",
      "detailedDescription": "We provide immersive visualization and smart design integration using 3D renders, VR walkthroughs, BIM modeling, and home automation.",
      "image": "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?auto=format&fit=crop&w=800&q=80",
      "features": ["3D Renders & Animated Walkthroughs", "VR Presentations", "BIM Modeling", "Smart Home Automation"]
    },
    {
      "title": "Renovation & Outdoor Design",
      "description": "Reimagine existing spaces inside and out",
      "detailedDescription": "We breathe new life into existing spaces through residential and commercial renovations, landscape design, and creative outdoor planning.",
      "image": "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=800&q=80",
      "features": ["Renovations", "Landscape Design", "Outdoor Planning"]
    },
    {
      "title": "Hospitality Design",
      "description": "Immersive design for luxury and comfort",
      "detailedDescription": "From hotels and resorts to villas and service apartments, our hospitality design prioritizes guest experience, comfort, and brand coherence.",
      "image": require('../assets/S88.webp'),
      "features": ["Hotels & Villas", "Service Apartments", "Guest-Centric Design"]
    },
    {
      "title": "Retail Design",
      "description": "Brand-focused environments that sell",
      "detailedDescription": "We design impactful retail spaces such as boutiques, showrooms, and experience centers to align with brand identity and maximize customer engagement.",
      "image": require('../assets/S66.webp'),
      "features": ["Experience Centers", "Pop-Ups", "Visual Merchandising"]
    },
    {
      "title": "Healthcare Facility Design",
      "description": "Designing patient-first healthcare spaces",
      "detailedDescription": "We create efficient, regulatory-compliant medical environments that prioritize user comfort and healthcare workflows.",
      "image": require('../assets/S55.webp'),
      "features": ["Clinics & Labs", "Hospital Design", "Wellness Centers"]
    },
    {
      "title": "Educational Facility Design",
      "description": "Inspiring learning spaces for the future",
      "detailedDescription": "Our educational design solutions foster effective learning through adaptive, safe, and technology-integrated spaces.",
      "image": require('../assets/S77.webp'),
      "features": ["School & Campus Design", "Skill Centers", "Flexible Classrooms"]
    },
    {
      "title": "Commercial Space Planning",
      "description": "Optimized layouts that boost performance",
      "detailedDescription": "We design commercial interiors—offices, studios, co-working areas—that reflect identity while enhancing productivity and adaptability.",
      "image": "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=800&q=80",
      "features": ["Open Plan Layouts", "Reception & Waiting", "Studio Planning"]
    },
    {
      "title": "Residential Architecture",
      "description": "Custom living environments crafted for you",
      "detailedDescription": "From flats to farmhouses, we bring your dream home to life with designs rooted in functionality and elegance.",
      "image": "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=800&q=80",
      "features": ["Villas & Flats", "Weekend Homes", "Gated Communities"]
    }
]
    // // Previous sample services (optional to keep or remove)
    // {
    //   title: "Sustainable Design Consulting",
    //   description: "Eco-friendly solutions for green building projects",
    //   detailedDescription: "Our sustainable design services help reduce environmental impact while creating healthy, energy-efficient spaces.",
    //   image: "https://images.unsplash.com/photo-1487958449943-2429e8be8625?auto=format&fit=crop&w=800&q=80",
    //   features: ["Energy Efficiency", "Material Lifecycle", "Certification Guidance"]
    // },
    // {
    //   title: "Historic Preservation",
    //   description: "Restoring and adapting historic structures",
    //   detailedDescription: "We specialize in adaptive reuse and preservation of historic buildings, maintaining authenticity while meeting modern needs.",
    //   image: "https://images.unsplash.com/photo-1533856493584-0c6ca8ca9ce3?auto=format&fit=crop&w=800&q=80",
    //   features: ["Archival Research", "Period Materials", "Code Compliance"]
    // },
    // {
    //   title: "Lighting Design",
    //   description: "Illuminating spaces with precision and art",
    //   detailedDescription: "We craft lighting solutions that enhance mood, task performance, and architectural expression using energy-efficient technologies.",
    //   image: "https://images.unsplash.com/photo-1513519245088-0e12902e5a38?auto=format&fit=crop&w=800&q=80",
    //   features: ["Ambience Creation", "Architectural Focus", "Daylight Integration"]
    // }
  ;

  const openModal = (service) => {
    setSelectedService(service);
    setIsModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setIsModalOpen(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <>
      <Header />
      <section id="services" className="py-20 pt-32 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: "#006039" }}>
              Our Services
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" style={{ color: "#000000" }}>
              Comprehensive architectural and design solutions for all your project needs
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                onClick={() => openModal(service)}
                className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold mb-3" style={{ color: "#006039" }}>{service.title}</h3>
                  <p className="text-gray-600 mb-4">{service.description}</p>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center text-gray-700">
                        <div className="w-2 h-2 bg-amber-500 rounded-full mr-3"></div>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {isModalOpen && selectedService && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true" onClick={closeModal}>
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>

            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                    <div className="relative h-64 w-full mb-6 overflow-hidden rounded-lg">
                      <img
                        src={selectedService.image}
                        alt={selectedService.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <h3 className="text-3xl leading-6 font-bold text-gray-900 mb-4">
                      {selectedService.title}
                    </h3>
                    <p className="text-gray-700 mb-6">{selectedService.detailedDescription}</p>
                    <div className="mb-6">
                      <h4 className="text-xl font-semibold mb-3">Key Features:</h4>
                      <ul className="space-y-2">
                        {selectedService.features.map((feature, idx) => (
                          <li key={idx} className="flex items-center text-gray-700">
                            <div className="w-2 h-2 bg-amber-500 rounded-full mr-3"></div>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  onClick={closeModal}
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
      <Chatbot />
    </>
  );
};

export default Services;
